export default "__VITE_ASSET__Bi8FFKv3__"